import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material/material.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { CommonComponentsModule } from '../common-components/common-components.module';
import { NodeRoutingModule } from './node-routing.module';
import { NodeStatusTableItemComponent } from './node-status-table-item/node-status-table-item.component';
import { NodeControlComponent } from './node-control/node-control.component';
import { NodeTransitionComponent } from './node-transition/node-transition.component';
import { NodeCommentsComponent } from './node-comments/node-comments.component';
import { NodeHeaderComponent } from './node-header/node-header.component';
import { NodeDocumentComponent } from './node-document/node-document.component';
import { NodeItemComponent } from './node-item/node-item.component';

@NgModule({
    declarations: [
        NodeStatusTableItemComponent,
        NodeControlComponent,
        NodeTransitionComponent,
        NodeHeaderComponent,
        NodeCommentsComponent,
        NodeDocumentComponent,
        NodeItemComponent
    ],
    imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule, PipesModule, CommonComponentsModule, NodeRoutingModule],
    exports: [
        NodeStatusTableItemComponent,
        NodeControlComponent,
        NodeTransitionComponent,
        NodeHeaderComponent,
        NodeCommentsComponent,
        NodeDocumentComponent,
        NodeItemComponent
    ]
})
export class NodeModule {}
